import { Checkbox } from "antd";
import SortIcon from "../../../global/components/SortIcon";
import usePost from "../../../global/hooks/usePost";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { useEffect } from "react";

export const OrderColumns = (
  setParams,
  params,
  dataSource,
  onSelectAll,
  refetch
) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const freeUrl = `${process.env.REACT_APP_API_URL}/api/orders/order-status/`;
  const {
    data: FreeData,
    loading: freeLoading,
    error: freeError,
    postData,
  } = usePost(freeUrl);

  const onSelectConfirm = async (record) => {
    try {
      if (record) {
        if (record.Free === "Yes") {
          await postData({ ids: [record.OrderNo], Free: 0 });
        } else {
          await postData({ ids: [record.OrderNo], Free: 1 });
        }
      }
    } catch (error) {
      openErrorNotification("Something went wrong");
    }
  };

  useEffect(() => {
    if (FreeData && !freeError) {
      openConfirmNotification("Success");
      refetch();
    } else if (freeError) {
      openErrorNotification(
        freeError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [FreeData, freeError]);

  return [
    // {
    //   title: "No",
    //   dataIndex: "OrderNo",
    //   key: "OrderNo",
    //   sorter: (a, b) => a?.OrderNo - b?.OrderNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OrderNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OrderNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      render: (text) => (
        <div>
          {typeof text === "string" && text.length >= 16
            ? text.slice(0, 16)
            : ""}
        </div>
      ),
      sorter: (a, b) => new Date(a.OrderTime) - new Date(b.OrderTime),
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OrderTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OrderTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "OEM",
      dataIndex: "OemName",
      key: "OemName",
      hidden: [4, 5, 6, 7, 8, 9].includes(loggedInUser?.role_value),
      sorter: (a, b) => a?.OemName - b?.OemName,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "DealerName",
      hidden: [7, 8, 9].includes(loggedInUser?.role_value),
      key: "DealerName",
      sorter: (a, b) => a?.DealerName - b?.DealerName,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Customer",
      dataIndex: "CustomerName",
      hidden: [10, 11, 12].includes(loggedInUser?.role_value),
      key: "CustomerName",
      sorter: (a, b) => a?.CustomerName - b?.CustomerName,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CustomerName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CustomerName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Mac"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Mac",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Item",
      dataIndex: "OrderItem",
      key: "OrderItem",
      sorter: (a, b) => a?.OrderItem?.length - b?.OrderItem?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OrderItem"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OrderItem",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      sorter: (a, b) => a?.OrderType?.length - b?.OrderType?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OrderType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OrderType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "License Time",
      dataIndex: "LicenseTime",
      key: "LicenseTime",
      // sorter: (a, b) => a?.LicenseTime?.length - b?.LicenseTime?.length,
      // sortIcon: () => (
      //   <SortIcon
      //     sortOrder={modParams.order}
      //     columnKey="LicenseTime"
      //     sortBy={modParams.sort_by}
      //   />
      // ),
      // onHeaderCell: () => ({
      //   onClick: () =>
      //     setParams((prev) => ({
      //       ...modParams,
      //       sort_by: "LicenseTime",
      //       order: modParams.order === "desc" ? "asc" : "desc",
      //     })),
      // }),
    },
    {
      title: "Old License",
      dataIndex: "OldCode",
      key: "OldCode",
      sorter: (a, b) => a?.OldCode?.length - b?.OldCode?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OldCode"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OldCode",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "New License",
      dataIndex: "NewCode",
      key: "NewCode",
      sorter: (a, b) => a?.NewCode?.length - b?.NewCode?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="NewCode"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "NewCode",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: () => {
        const allRowFree = dataSource?.every((item) => item.Free === "Yes");
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Checkbox
              className="text-[#374151] text-sm font-medium"
              checked={allRowFree}
              onChange={() => {
                // setSelectedRowKeys(dataSource?.map((item) => item.OrderNo));
                onSelectAll(dataSource?.map((item) => item.OrderNo));
              }}
            />
            <span>Free</span>
          </div>
        );
      },
      dataIndex: "Free",
      key: "Free",
      render: (text, record) => (
        <div>
          <Checkbox
            className="text-[#374151] text-sm font-medium"
            checked={text === "Yes"}
            onChange={() => {
              onSelectConfirm(record);
              // setSelectedRowKeys([record?.OrderNo]);
            }}
          />
        </div>
      ),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};

export const OrderItemColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setShowForm,
  setFormType,
  setSelectedOrderItemNo
) => {
  return [
    {
      title: "No",
      dataIndex: "ItemNo",
      key: "ItemNo",
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
    },
    {
      title: "Order Item",
      dataIndex: "OrderItem",
      key: "OrderItem",
    },
    {
      title: "Old Code",
      dataIndex: "OldCode",
      key: "OldCode",
    },
    {
      title: "Old Price",
      dataIndex: "OldPrice",
      key: "OldPrice",
    },
    {
      title: "New Code",
      dataIndex: "NewCode",
      key: "NewCode",
    },
    {
      title: "New Price",
      dataIndex: "NewPrice",
      key: "NewPrice",
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
